module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_zx_pre (1).f79cca59.png";